import {
  getCountsQueryKey as getExternalCountsQueryKey,
  getOperatorCountsQueryKey,
  getOperatorRequestsQueryKey,
  getRequestQueryKey as getExternalRequestQueryKey,
  getRequestsQueryKey as getExternalRequestsQueryKey,
} from "@synthesis/shared-services/external/application/hooks";
import {
  get2QueryKey as getInternalFinalDecisionDraftQueryKey,
  getCountsQueryKey as getInternalCountsQueryKey,
  getCurrentVersionQueryKey as getInternalFinalDecisionCurrentVersionQueryKey,
  getRefusalQueryKey as getInternalFinalDecisionRefusalQueryKey,
  getRequestQueryKey as getInternalRequestQueryKey,
  getRequestsQueryKey as getInternalRequestsQueryKey,
  getVersionsQueryKey as getInternalFinalDecisionVersionsQueryKey,
  listQueryKey as getInternalTuPartsListQueryKey,
} from "@synthesis/shared-services/internal/application/hooks";
import type { QueryClient } from "@tanstack/react-query";

export const invalidateInternalApplicationQueries = async (queryClient: QueryClient, requestId?: string) => {
  await Promise.all([
    ...(requestId
      ? [
          queryClient.invalidateQueries({ queryKey: getInternalRequestQueryKey({ path: { id: requestId } }) }),
          // resetQueries, не invalidate: после submit-ntp-approval / rework-resubmit query
          // становится enabled:false и stale-данные иначе остаются в кеше («Решение не отправлено»).
          // При возврате на доработку нужен свежий GET (часто FINAL_DECISION_NOT_FOUND).
          queryClient.resetQueries({ queryKey: getInternalFinalDecisionDraftQueryKey({ path: { requestId } }) }),
          queryClient.invalidateQueries({ queryKey: getInternalFinalDecisionCurrentVersionQueryKey({ path: { requestId } }) }),
          queryClient.invalidateQueries({ queryKey: getInternalFinalDecisionVersionsQueryKey({ path: { requestId } }) }),
          queryClient.invalidateQueries({ queryKey: getInternalFinalDecisionRefusalQueryKey({ path: { requestId } }) }),
          queryClient.invalidateQueries({ queryKey: ["regional-departments", requestId] }),
          queryClient.invalidateQueries({ queryKey: getInternalTuPartsListQueryKey({ path: { requestId } }) }),
        ]
      : []),
    queryClient.invalidateQueries({ queryKey: getInternalRequestsQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getInternalCountsQueryKey() }),
  ]);
};

export const invalidateExternalApplicationQueries = async (queryClient: QueryClient, requestId?: string) => {
  await Promise.all([
    ...(requestId ? [queryClient.invalidateQueries({ queryKey: getExternalRequestQueryKey({ path: { id: requestId } }) })] : []),
    queryClient.invalidateQueries({ queryKey: getExternalRequestsQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getExternalCountsQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getOperatorRequestsQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getOperatorCountsQueryKey() }),
  ]);
};
